import React, { useContext, useEffect } from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { CategoryContext } from "../Contexts/CategoryContext";
import { Helmet } from "react-helmet-async";
import Loading from "../pages/Loading";
import ReactGA from "react-ga";
import Aos from "aos";
import "aos/dist/aos.css";

ReactGA.pageview(window.location.pathname + window.location.search);

const Shop = () => {
  const { category, loading, error, fetchCategories } =
    useContext(CategoryContext);
  useEffect(() => {
    Aos.init({ duration: 100 });
    Aos.refresh();
    fetchCategories();
  }, []);

  return (
    <div>
      <Helmet>
        <title>SAWA | Shop</title>
        <meta name="description" content="Shop our latest artworks now." />
        <link rel="canonical" href="/shop" />
      </Helmet>
      <NavBar />
      <section className="relative h-[80vh] flex flex-col justify-center items-center text-gray-50">
        <img
          src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1500/v1727706284/s8ssmqdjtusq0dr54j82.webp"
          alt="Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-60 z-10"></div>
        <div
          className="relative z-20 text-center px-4 sm:px-6 lg:px-8"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold mb-4">
            Shop Now
          </h1>
          <p className="max-w-lg demfont demline font-poppins mt-10 sm:max-w-xl md:max-w-2xl lg:max-w-4xl font-light mx-auto text-lg sm:text-xl md:text-2xl">
            Explore a collection of paintings, limited prints, and sculptures
            that capture the essence of our stunning wildlife. Every purchase
            you make contributes to our{" "}
            <span className="font-semibold">
              <a
                href="/conservation"
                className="text-green-400 hover:text-green-800 underline focus:outline-none"
              >
                TUZIVUGIRE
              </a>
            </span>{" "}
            conservation program, helping to protect the natural wonders that
            inspire our art.
          </p>
        </div>
        <div className="absolute top-0 left-0 w-full h-full border-l-[1px] border-b-[3px] border-white z-10 pointer-events-none"></div>
      </section>
      {loading ? (
        <Loading /> // Display the Loading component while loading is true
      ) : error ? (
        <div>Error: {error.message}</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-4 md:px-12 lg:px-48 py-20">
          {category.map((cat, index) => (
            <div
              className="relative overflow-hidden rounded-lg shadow-lg"
              key={cat._id}
              data-aos="fade-down"
              data-aos-duration="500"
            >
              <a
                href={`/shop/${cat._id}${
                  cat.collections.length ? "/collections" : "/artworks"
                }`}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              >
                <img
                  src={`${cat.image}`}
                  alt={cat.name}
                />
                <div
                  className="absolute bottom-4 left-4 text-white p-5"
                  data-aos="fade-in"
                  data-aos-duration="1000"
                >
                  <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold">
                    {cat.name}
                  </h3>
                  <button className="bg-white text-black font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center">
                    Shop
                  </button>
                </div>
              </a>
            </div>
          ))}
          {/* <div
            className="relative overflow-hidden rounded-lg shadow-lg"
            data-aos="fade-down"
            data-aos-duration="500"
          >
            <img
              src="https://res.cloudinary.com/duchitv8b/image/upload/v1727809785/Limited_Prints_fmddv2.webp"
              alt="Crafts"
            />
            <div className="absolute inset-0 bg-black opacity-70"></div>
            <div
              className="absolute bottom-4 left-4 text-white p-5"
              data-aos="fade-in"
              data-aos-duration="1000"
            >
              <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold">
                Limited Prints
              </h3>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold">
                Coming Soon
              </h2>
              <button className="bg-white text-black font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center">
                Shop
              </button>
            </div>
          </div>
          <div
            className="relative overflow-hidden rounded-lg shadow-lg"
            data-aos="fade-down"
            data-aos-duration="500"
          >
            <img
              src="https://res.cloudinary.com/duchitv8b/image/upload/v1727810113/Crafts_i76xat.webp"
              alt="Crafts"
            />
            <div className="absolute inset-0 bg-black opacity-70"></div>
            <div
              className="absolute bottom-4 left-4 text-white p-5"
              data-aos="fade-in"
              data-aos-duration="1000"
            >
              <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold">
                Crafts
              </h3>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold">
                Coming Soon
              </h2>
              <button className="bg-white text-black font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center">
                Shop
              </button>
            </div>
          </div>
          <div
            className="relative overflow-hidden rounded-lg shadow-lg"
            data-aos="fade-down"
            data-aos-duration="500"
          >
            <img
              src="https://res.cloudinary.com/duchitv8b/image/upload/v1727810113/Sculpture_uzdkv1.webp"
              alt="Sculptures"
            />
            <div className="absolute inset-0 bg-black opacity-70"></div>
            <div
              className="absolute bottom-4 left-4 text-white p-5"
              data-aos="fade-in"
              data-aos-duration="1000"
            >
              <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold">
                Sculptures
              </h3>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold">
                Coming Soon
              </h2>
              <button className="bg-white text-black font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center">
                Shop
              </button>
            </div>
          </div> */}
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Shop;
